import { render, staticRenderFns } from "./inputField.vue?vue&type=template&id=2047f74d&scoped=true"
import script from "./inputField.vue?vue&type=script&lang=js"
export * from "./inputField.vue?vue&type=script&lang=js"
import style0 from "./inputField.vue?vue&type=style&index=0&id=2047f74d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2047f74d",
  null
  
)

export default component.exports